import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BookOpen, ArrowRight, Clock, Calendar } from 'lucide-react';
import './ThoughtLeadership.css';

// 1. Accept 'data' prop
const ThoughtLeadership = ({ data }) => {
  const navigate = useNavigate();

  // 2. Safety Check: Default to empty array if data is missing
  const articles = data || [];

  if (articles.length === 0) {
    return null; // Don't render if empty
  }

  const handleReadMore = (id) => {
    navigate(`/article/${id}`);
    window.scrollTo(0, 0);
  };

  return (
    <section className="articles-section" id="articles">
      <div className="articles-container">
        
        <div className="section-header">
          <h2 className="section-title">THOUGHT_LEADERSHIP</h2>
          <p className="section-subtitle">Security Research & Technical Analysis</p>
        </div>

        <div className="articles-grid">
          {articles.map((article) => (
            <div key={article.id} className="article-card" onClick={() => handleReadMore(article.id)}>
              <div className="article-content">
                <div className="article-meta-top">
                  <span className="article-category">{article.category}</span>
                  <BookOpen size={16} className="meta-icon" />
                </div>

                <h3 className="article-title">{article.title}</h3>
                <p className="article-excerpt">{article.excerpt}</p>

                <div className="article-footer">
                  <div className="meta-info">
                    <span className="meta-item">
                      <Calendar size={14} />
                      {article.date}
                    </span>
                    <span className="meta-item">
                      <Clock size={14} />
                      {article.readTime}
                    </span>
                  </div>
                  <span className="read-more-btn">
                    READ_LOG <ArrowRight size={16} />
                  </span>
                </div>
              </div>
              
              <div className="article-hover-effect"></div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ThoughtLeadership;